import { isWeb } from '@/utils/constants-platform-specific';

import { getBreakpointByWidth } from '../utils/breakpoints';
import { useResponsiveDimensions } from './use-responsive-dimensions';

/**
 * Whether the app is running on web at a desktop-sized viewport (the `lg` breakpoint).
 * Always false on native.
 */
export const useIsDesktopWeb = () => {
    const { width } = useResponsiveDimensions();

    return isWeb && getBreakpointByWidth(width) === 'lg';
};
